
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$badge.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$badge.js';
export default __default__;
